import useTranslation from 'next-translate/useTranslation';
import { GameLeaderboardTableHeaderProps } from './props';
import styles from './styles.module.scss';
import defaultStyles from '../styles.module.scss';

export default function GameLeaderboardTableHeader({
  shouldShowReducedInfo,
}: GameLeaderboardTableHeaderProps) {
  const { t } = useTranslation('smash-racing');
  const { t: tDataGrid } = useTranslation('data-grid');

  return (
    <thead className={styles.container}>
      <tr className={defaultStyles.table__row}>
        <td className={defaultStyles.table__row__data}>
          {t('table_column_name')}
        </td>

        {!shouldShowReducedInfo ? (
          <>
            <td
              className={`${defaultStyles.table__row__data} ${defaultStyles['table__row__data--center']}`}
            >
              {t('table_column_multiplier')}
            </td>

            <td
              className={`${defaultStyles.table__row__data} ${defaultStyles['table__row__data--center']}`}
            >
              {t('value_label')}
            </td>

            <td
              className={`${defaultStyles.table__row__data} ${defaultStyles['table__row__data--right']}`}
            >
              {tDataGrid('profit_label')}
            </td>
          </>
        ) : (
          <td
            className={`${defaultStyles.table__row__data} ${defaultStyles['table__row__data--right']}`}
          >
            {tDataGrid('tab_bet')}
          </td>
        )}
      </tr>
    </thead>
  );
}
